import { RadioChangeEvent, Space, Checkbox } from 'antd';
import { Radio, Button } from '@maxtropy/components';
import { useHasPermission } from '../../../utils/utils';
import { PermissionsType } from '../../../common/permissionsConst';
import { FC, useState } from 'react';
import { V2RuleAlarmLogAlarmLevelCountPostResponse } from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';
import { GradeEnum } from '../const';
import { AlarmLogResponse } from '../../../api/alarm';
export interface DateSwitchProps {
  selectedKeys: number[];
  adjustRestore: () => void;
  batchDel: () => void;
  records: AlarmLogResponse[];
  readAllLog: () => void;
  exportAction: () => void;
  gradeDatas: V2RuleAlarmLogAlarmLevelCountPostResponse;
  setLevels?: (levels: number[]) => void;
  autoRefresh?: boolean;
  setAutoRefresh?: (checked: boolean) => void;
}

const GradeSwitch: FC<DateSwitchProps> = props => {
  const {
    exportAction,
    readAllLog,
    records,
    adjustRestore,
    batchDel,
    selectedKeys,
    gradeDatas,
    setLevels,
    autoRefresh,
    setAutoRefresh,
  } = props;

  const hasLowestLevelTab = useHasPermission(PermissionsType.B_LOWESTLEVELTAB);
  const hasLowLevelTab = useHasPermission(PermissionsType.B_LOWLEVELTAB);
  const hasIntermediateTab = useHasPermission(PermissionsType.B_INTERMEDIATETAB);
  const hasAdvancedTab = useHasPermission(PermissionsType.B_ADVANCEDTAB);
  const hasSuperlativeTab = useHasPermission(PermissionsType.B_SUPERLATIVETAB);
  const hasMarkAllReadCurrentPage = useHasPermission(PermissionsType.B_MARKALLREADCURRENTPAGE);
  const hasDeleteAlarm = useHasPermission(PermissionsType.B_DELETEALARM);

  const [grade, setGrade] = useState(GradeEnum.ALL);

  const onRadioChange = (e: RadioChangeEvent) => {
    setGrade(e.target.value);
    e.target.value !== GradeEnum.ALL ? setLevels?.([e.target.value]) : setLevels?.([]);
  };

  return (
    <Space className={styles.dateSwitch} size={16}>
      <Space>
        <Radio.Group onChange={onRadioChange} value={grade} buttonStyle="solid">
          <Radio.Button value={GradeEnum.ALL}>全部({gradeDatas?.total ?? 0})</Radio.Button>
          {hasSuperlativeTab && <Radio.Button value={GradeEnum.TOP}>最高级({gradeDatas?.topLevel ?? 0})</Radio.Button>}
          {hasAdvancedTab && <Radio.Button value={GradeEnum.HIGH}>高级({gradeDatas?.highLevel ?? 0})</Radio.Button>}
          {hasIntermediateTab && (
            <Radio.Button value={GradeEnum.MIDDLE}>中级({gradeDatas?.middleLevel ?? 0})</Radio.Button>
          )}
          {hasLowLevelTab && <Radio.Button value={GradeEnum.LOW}>低级({gradeDatas?.lowLevel ?? 0})</Radio.Button>}
          {hasLowestLevelTab && (
            <Radio.Button value={GradeEnum.LOWEST}>最低级({gradeDatas?.lowestLevel ?? 0})</Radio.Button>
          )}
        </Radio.Group>
      </Space>

      <Space size={8}>
        <Button type="primary" disabled={!selectedKeys.length} onClick={adjustRestore}>
          解除报警
        </Button>
        {hasMarkAllReadCurrentPage && !window.alarmRecordReadTimeHide && (
          <Button type="primary" disabled={(records ?? []).length === 0} onClick={readAllLog}>
            批量已读当前页
          </Button>
        )}
        {hasDeleteAlarm && (
          <Button type="primary" disabled={!selectedKeys.length} onClick={batchDel}>
            批量删除
          </Button>
        )}
        <Button type="primary" disabled={(records ?? []).length === 0} onClick={() => exportAction()}>
          导出
        </Button>
        <Checkbox checked={autoRefresh} onChange={e => setAutoRefresh?.(e.target.checked)}>
          自动刷新
        </Checkbox>
      </Space>
    </Space>
  );
};

export default GradeSwitch;
